<div class="input-container">
    <label for="uploads_backblaze_application_key" trans>Backblaze Application (Master) Key</label>
    <input type="text" id="uploads_backblaze_application_key" name="uploads_backblaze_application_key" [(ngModel)]="state.server['uploads_backblaze_application_key']" required>
</div>

<div class="input-container">
    <label for="uploads_backblaze_account_id" trans>Backblaze Account ID</label>
    <input type="text" id="uploads_backblaze_account_id" name="uploads_backblaze_account_id" [(ngModel)]="state.server['uploads_backblaze_account_id']" required>
</div>

<div class="input-container">
    <label for="uploads_backblaze_bucket" trans>Backblaze Bucket</label>
    <input type="text" id="uploads_backblaze_bucket" name="uploads_backblaze_bucket" [(ngModel)]="state.server['uploads_backblaze_bucket']" required>
</div>